import { render, staticRenderFns } from "./kirimantitipanerror.vue?vue&type=template&id=727a4682"
import script from "./kirimantitipanerror.vue?vue&type=script&lang=js"
export * from "./kirimantitipanerror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports